/**
 * Created by staffanrantzow on 24/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';
import { connect } from 'react-redux';
import { CustomerService } from 'frilans-finans';
import CustomerRow from './customer-row';
import ReactPaginate from 'react-paginate';
import Spinner from 'components/spinner/spinner';
import { ConfirmModal } from 'components';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import { GeneralError } from 'components/general-error/general-error';

export class Customers extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      customers: [],
      fetching: true,
      fetchError: false,
      deleteError: false,
      errorMessage: false,
      contentFetched: false,
      page: 1,
      pageRange: 5,
      totalPages: 1,
      meta: {
        totalPages: 1
      },
      renderConfirmModal: false,
      customerToDelete: null,
      pendingRequest: null
    };

    this.handlePaginationClick = this.handlePaginationClick.bind(this);
    this.handleError = this.handleError.bind(this);
    this.onRemoveClick = this.onRemoveClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.fetchCustomers = this.fetchCustomers.bind(this);
  }

  componentDidMount () {
    this.fetchCustomers();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest) {
      this.state.pendingRequest.cancel();
    }
  }

  fetchCustomers () {
    const userId = +this.props.user.id;

    let pendingRequest = CustomerService.get(userId, this.state.page);
    pendingRequest.promise
      .then((response) => this.handleResponse(response))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (apiResult) {
    this.setState({
      fetching: false,
      customers: apiResult.collection,
      contentFetched: true,
      total: apiResult.meta.total,
      totalPages: Math.ceil(apiResult.meta.total / apiResult.meta.currentPage),
      meta: apiResult.meta
    });
  }

  handleError (error) {
    let errors = CustomerService.getError(error);

    this.setState({
      fetching: false,
      deleteError: true,
      errorMessage: errors
    });
  }

  handlePaginationClick (data) {
    this.setState({
      page: data.selected + 1,
      fetching: true
    }, this.fetchCustomers.bind(this));
  }

  onRemoveClick (customer) {
    this.setState({
      renderConfirmModal: true,
      customerToDelete: customer
    });
  }

  closeModal (confirm) {
    if (confirm) {
      CustomerService.delete(this.state.customerToDelete.id)
        .then(this.fetchCustomers)
        .catch(this.handleError);

      this.setState({
        fetching: true,
        renderConfirmModal: false,
        customerToDelete: null
      });
    } else {
      this.setState({
        renderConfirmModal: false,
        customerToDelete: null
      });
    }
  }

  renderError () {
    if (this.state.deleteError) {
      if (!this.state.errorMessage) {
        return (<GeneralError />);
      } else {
        return (
          <div>
            {this.state.errorMessage.map((error, i) => {
              return (
                <p className='error' key={i}>{error}</p>
              );
            })}
          </div>
        );
      }
    }
  }

  renderConfirmModal () {
    if (this.state.renderConfirmModal) {
      return (
        <ConfirmModal
          callback={this.closeModal}
          message={proxyCounterpart('DELETE_CUSTOMER', {name: this.state.customerToDelete.name})}
        />
      );
    }
  }

  renderLoader () {
    var tableContent, classes;

    tableContent = this.state.contentFetched ? this.renderTable() : false;
    classes = this.state.contentFetched ? 'loader-wrapper absolute' : 'loader-wrapper';

    return (
      <div className='table-loading'>
        <div className={classes}>
          <Spinner />
        </div>
        {tableContent}
        <div className='overlay'></div>
      </div>
    );
  }

  renderTable () {
    let onRemoveClick = this.onRemoveClick;

    return (
      <div className='table-wrapper mobile-full-width-table'>
        <table className='standard-table'>
          <thead>
            <tr>
              <th className='col-customer'><Translate content='CUSTOMER'/></th>
              <th className='col-orgnr'><Translate content='ORG_NR'/></th>
              <th className='col-ref'><Translate content='REF'/></th>
              <th className='col-address'><Translate content='ADDRESS'/></th>
              <th className='col-edit'><Translate content='EDIT'/></th>
              <th className='col-edit'><Translate content='DELETE'/></th>
            </tr>
          </thead>
          <tbody>
            {this.state.customers.map(function (customer, i) {
              return <CustomerRow customer={customer} remove={onRemoveClick} key={i} />;
            })}
          </tbody>
        </table>

      </div>
    );
  }

  renderFetchError () {
    return (<p className='error'><Translate content='GENERAL_ERROR'/></p>);
  }

  renderNoResult () {
    return (<p className='info'><Translate content='NO_CUSTOMERS'/></p>);
  }

  renderPagination () {
    if (this.state.contentFetched && this.state.meta.totalPages > 1) {
      return (
        <ReactPaginate
          breakLabel={<a href=''>...</a>}
          pageNum={this.state.meta.totalPages}
          marginPagesDisplayed={3}
          pageRangeDisplayed={this.state.pageRange}
          clickCallback={this.handlePaginationClick}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          previousLabel=''
          nextLabel=''
          containerClassName='pagination' />
      );
    }

    return false;
  }

  getContent () {
    if (this.state.fetchError) {
      return this.renderFetchError();
    }
    if (this.state.fetching) {
      return this.renderLoader();
    }
    if (this.state.customers.length === 0 && this.state.contentFetched) {
      return this.renderNoResult();
    } else {
      return this.renderTable();
    }
  }

  render () {
    var content = this.getContent();

    return (
      <div className='customers'>
        <h2><Translate content='MY_CUSTOMERS'/></h2>
        <p><Translate content='MY_CUSTOMERS_TEXT'/></p>
        {content}
        {this.renderError()}
        {this.renderPagination()}
        {this.renderConfirmModal()}
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    user: state.user
  };
};

export default connect(
  mapStateToProps,
)(Customers);



/** WEBPACK FOOTER **
 ** ./src/views/customers/customers.js
 **/